/* 
 Manage the interactions bvetween partial views in the KVP user registration workflow
 */

$(function () {             // shorthand for getting rid of document ready

    const orgTypeSelectList      : HTMLSelectElement = <HTMLSelectElement>$('#OrganisationTypeSelect')[0];      
                                                                                                                
    const lhaSelectForm          : HTMLInputElement  = <HTMLInputElement> $('#LHAOrganisationSelectForm')[0];    
    const lhaSelectList          : HTMLInputElement  = <HTMLInputElement> $('#LHAOrganisationSelect')[0];        
                                                                                                                
    const utilitySelectForm      : HTMLInputElement  = <HTMLInputElement> $('#UtilityOrganisationSelectForm')[0];
    const utilitySelectList      : HTMLInputElement  = <HTMLInputElement> $('#UtilityOrganisationSelect')[0];    
                                                                                                                
    const utilityOtherOrgCheckbox: HTMLInputElement  = <HTMLInputElement> $('#chkUtilityOtherOrganisation')[0];  
    const utilityOtherMessage                        =                    $('#txtOtherOrganisationMessage')[0];                    
                                                                                                                
                                                                                                                
    const contractorSelectForm   : HTMLInputElement  = <HTMLInputElement> $('#ContractorSelectForm')[0];         
    const contractorSelectList   : HTMLInputElement  = <HTMLInputElement> $('#ContractorSelect')[0];             
    const otherContractorCheckbox: HTMLInputElement  = <HTMLInputElement> $('#chkOtherContractor')[0];           
    const otherContractorValue   : HTMLInputElement  = <HTMLInputElement> $('#ContractorOtherInput')[0];         
    const otherContractorForm                        =                    $('#ContractorOtherForm')[0];                            
                                                                                                                
    const roleSelectForm         : HTMLInputElement  = <HTMLInputElement> $('#RoleSelectForm')[0];               
    const roleSelectList         : HTMLInputElement  = <HTMLInputElement> $('#RoleSelect')[0];                   
    const otherRoleCheckbox      : HTMLInputElement  = <HTMLInputElement> $('#chkOtherRole')[0];                 
    const otherRoleValue         : HTMLInputElement  = <HTMLInputElement> $('#RoleOtherInput')[0];               
    const otherRoleForm                              =                    $('#RoleOtherForm')[0];                                  


    const WorkingRegionsValue    : HTMLInputElement = <HTMLInputElement>$('#WorkingRegions')[0]; 
    const LondonCheckbox         : HTMLInputElement = <HTMLInputElement>$('#chkLondon')[0];           
    const SouthEastCheckbox      : HTMLInputElement = <HTMLInputElement>$('#chkSouthEast')[0];           
    const SouthWestCheckbox      : HTMLInputElement = <HTMLInputElement>$('#chkSouthWest')[0];           
    const NorthEastCheckbox      : HTMLInputElement = <HTMLInputElement>$('#chkNorthEast')[0];
    const NorthWestCheckbox      : HTMLInputElement = <HTMLInputElement>$('#chkNorthWest')[0];     
    const EastOfEnglandCheckbox  : HTMLInputElement = <HTMLInputElement>$('#chkEastOfEngland')[0];     
    const EastMidlandsCheckbox   : HTMLInputElement = <HTMLInputElement>$('#chkEastMidlands')[0];     
    const WestMidlandsCheckbox   : HTMLInputElement = <HTMLInputElement>$('#chkWestMidlands')[0];     
    const YorkshireCheckbox      : HTMLInputElement = <HTMLInputElement>$('#chkYorkshire')[0];     
    const WalesCheckbox          : HTMLInputElement = <HTMLInputElement>$('#chkWales')[0];     
    const ScotlandCheckbox       : HTMLInputElement = <HTMLInputElement>$('#chkScotland')[0];     
    const NorthernIrelandCheckbox: HTMLInputElement = <HTMLInputElement>$('#chkNI')[0];     

    const currentUrl                                 = window.location.href;

    jQuery.validator.addMethod("customOrgSelect", function (value, element) {
        return lhaSelectList.value.length > 0
            || utilitySelectList.value.length > 0
            || contractorSelectList.value.length > 0
            || utilityOtherOrgCheckbox.checked
            || otherContractorCheckbox.checked
            || currentUrl.indexOf('/useradmin/') > 0   // user admin editing needs to be able to escape this validation

    }, "Please select your organisation from the available drop-down lists");


    $("#LHAOrganisationSelect").rules("add", {
        customOrgSelect: true, messages: { customOrgSelect: "Please select an Organisation" }
    });

    $("#UtilityOrganisationSelect").rules("add", {
        customOrgSelect: true, messages: { customOrgSelect: "Please select an Organisation or Company" }
    });

    $("#ContractorSelect").rules("add", {
        customOrgSelect: true, messages: { customOrgSelect: "Please select an Organisation or Company" }
    });


    /* org type affects the org selections available */

    orgTypeSelectList.addEventListener('change', (event) => {
        switch ((event.target as HTMLInputElement).value) {
            case "LHA":
                lhaSelectForm.style.display = "block";
                hideUtilityForm();
                hideContractorForm();

                break;

            case "Utility":
                hideLHAForm();
                utilitySelectForm.style.display = "block";
                hideContractorForm();

                break;

            case "Contractor":
                hideLHAForm();
                hideUtilityForm();
                contractorSelectForm.style.display = "block";

                break;

            default:
                break;
        }
    });


    /* utility org selection */

    utilityOtherOrgCheckbox.addEventListener('change', (event) => {
        if ((event.target as HTMLInputElement).checked) {
            $("#UtilityOrganisationSelect").removeClass("is-invalid");
            $("#UtilityOrganisationSelect-error").hide();
            utilitySelectList.value = "";
            utilityOtherMessage.style.display = "block";
        } else {
            utilityOtherMessage.style.display = "none";
        }
    });

    utilitySelectList.addEventListener('change', (event) => {
        if ((event.target as HTMLInputElement).value != "") {
            utilityOtherOrgCheckbox.checked = false;
            utilityOtherMessage.style.display = "none";
        }
    });


    /* contractor (non SWA) org selection */

    otherContractorCheckbox.addEventListener('change', (event) => {
        if ((event.target as HTMLInputElement).checked) {
            $("#ContractorSelect").removeClass("is-invalid");
            $("#ContractorSelect-error").hide();
            otherContractorForm.style.display = "block";
            contractorSelectList.value = "";
        } else {
            otherContractorValue.value = "";
            otherContractorForm.style.display = "none";
        }
    });

    contractorSelectList.addEventListener('change', (event) => {
        if ((event.target as HTMLInputElement).value != "") {
            otherContractorValue.value        = "";
            otherContractorForm.style.display = "none";
            otherContractorCheckbox.checked   = false;
        }
    });


    /* role selection */

    otherRoleCheckbox.addEventListener('change', (event) => {
        if ((event.target as HTMLInputElement).checked) {
            otherRoleForm.style.display = "block";
            roleSelectList.value = "";
        } else {
            otherRoleValue.value = "";
            otherRoleForm.style.display = "none";
        }
    });

    roleSelectList.addEventListener('change', (event) => {
        if ((event.target as HTMLInputElement).value != "") {
            otherRoleValue.value = "";
            otherRoleForm.style.display = "none";
            otherRoleCheckbox.checked = false;
        }
    });


    /* loading user edit screens only */

    if (orgTypeSelectList.value != null) {
        switch (orgTypeSelectList.value) {
            case "Contractor":

                hideLHAForm();
                hideUtilityForm();

                contractorSelectForm.style.display = "block";
                break;

            case "Utility":

                hideLHAForm();
                hideContractorForm();

                utilitySelectForm.style.display = "block";
                break;

            case "LHA":

                hideUtilityForm();
                hideContractorForm();

                lhaSelectForm.style.display = "block";
                break;
            default:
                break;
        }
    }


    if (orgTypeSelectList.value == 'Utility' && utilitySelectList.value == "") {
        utilityOtherOrgCheckbox.checked   = true;
        utilityOtherMessage.style.display = "block";
    }


    function hideLHAForm() {
        lhaSelectList.value         = "";
        lhaSelectForm.style.display = "none";
    }

    function hideUtilityForm() {
        utilitySelectList.value           = "";
        utilitySelectForm.style.display   = "none";
        utilityOtherOrgCheckbox.checked   = false;
        utilityOtherMessage.style.display = "none";
    }

    function hideContractorForm() {
        contractorSelectList.value         = "";
        contractorSelectForm.style.display = "none";
        otherContractorValue.value         = "";
        otherContractorForm.style.display  = "none";
        otherContractorCheckbox.checked    = false;
    }


    /* region selection */

    LondonCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "Greater London");
    });

    SouthEastCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "South East");
    });

    SouthWestCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "South West");
    });

    NorthEastCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "North East");
    });

    NorthWestCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "North West");
    });

    EastOfEnglandCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "East of England");
    });

    EastMidlandsCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "East Midlands");
    });

    WestMidlandsCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "West Midlands");
    });

    YorkshireCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "Yorkshire & Humberside");
    });

    WalesCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "Wales");
    });

    ScotlandCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "Scotland");
    });

    NorthernIrelandCheckbox.addEventListener('change', (event) => {
        concatenateRegion(event.target as HTMLInputElement, "Northern Ireland");
    });

    function concatenateRegion(target: HTMLInputElement, value: string) {
        if (target.checked) {
            if (WorkingRegionsValue.value.trim().length > 0) {
                WorkingRegionsValue.value += ",";
            }
            WorkingRegionsValue.value += value;
        } else {
            if (WorkingRegionsValue.value.startsWith(value)) {
                let newValue = WorkingRegionsValue.value.replace(value + ',', '').replace(value, '');
                WorkingRegionsValue.value = newValue;
            }
            else {
                let newValue = WorkingRegionsValue.value.replace(',' + value, '').replace(value, '');
                WorkingRegionsValue.value = newValue;
            }
        }
    }
});

